import { DataGrid, GridColDef } from '@mui/x-data-grid';
import EntityAppService from '../../../../application/platform/scp/entity/entitiy-app-service';
import { useArrayList } from '../../../../hooks/use-array-list';
import { dataGridDefaults } from '../../../../components/list-grid-panel';
import { IUnidEntityResponse } from '../../../../model/scp/entity/response/unid-entity-response';

const columns: GridColDef<IUnidEntityResponse>[] = [
    { field: 'id', headerName: 'Id', width: 90 },
    { field: 'unitCode', headerName: 'Código', width: 140 },
    { field: 'name', headerName: 'Nome', flex: 1, minWidth: 220 },
];

// A API não pagina nem filtra: a grade pagina no navegador
export default function UnidEntityDataTable({ searchTrigger }: { searchTrigger: number }) {
    const { rows, loading } = useArrayList(() => EntityAppService.listUnidEntity(), undefined, searchTrigger, 'Não foi possível carregar as unidades');

    return (
        <DataGrid
            {...dataGridDefaults}
            rows={rows}
            columns={columns}
            loading={loading}
            initialState={{ pagination: { paginationModel: { pageSize: 25, page: 0 } } }}
        />
    );
}
